import { useEffect, useState } from 'react';
import { NineSliceFrame } from './NineSliceFrame';
import { KeyDisplay } from './KeyDisplay';
import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import './ConfirmPopup.scss';

interface QuantityPopupProps {
  title: string;
  max: number;
  confirmLabel?: string;
  onConfirm: (amount: number) => void;
  onCancel: () => void;
}

export const QuantityPopup = ({
  title,
  max,
  confirmLabel = 'Jeter',
  onConfirm,
  onCancel,
}: QuantityPopupProps) => {
  const [amount, setAmount] = useState(1);

  const { containerRef } = useMenuNavigation({
    onConfirm: () => onConfirm(amount),
    onCancel,
    onLeft: () => setAmount((a) => Math.max(1, a - 1)),
    onRight: () => setAmount((a) => Math.min(max, a + 1)),
    focusClass: 'confirm-popup-focused',
  });

  useEffect(() => {
    setAmount(1);
  }, [max]);

  return (
    <div className="confirm-popup-overlay">
      <NineSliceFrame className="confirm-popup">
        <h3 className="confirm-popup-title">{title}</h3>
        <p className="confirm-popup-message">
          {amount} / {max}
        </p>
        <div className="confirm-popup-actions" ref={containerRef}>
          <span
            data-nav-row={0}
            data-nav-col={0}
            data-nav-id="quantity"
            style={{ display: 'none' }}
          />
        </div>
        <div className="confirm-popup-hint">
          <KeyDisplay context="interface" action="LEFT" size="sm" />
          <KeyDisplay context="interface" action="RIGHT" size="sm" />
          <KeyDisplay context="interface" action="CONFIRM" size="sm" />
          <span>{confirmLabel}</span>
          <KeyDisplay context="interface" action="CANCEL" size="sm" />
        </div>
      </NineSliceFrame>
    </div>
  );
};
